import { getWhiteLabel } from "./white-label";

export const setGtm = () => {
  const { tagManagerKey } = getWhiteLabel();

  if (!tagManagerKey) return;
  if (document.querySelector("#_gtm")) return;

  const dataLayerInit = document.createElement("script");
  dataLayerInit.id = "_gtm-init";
  dataLayerInit.textContent =
    "(function(w,l){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});})(window,'dataLayer');";
  document.head.append(dataLayerInit);

  const gtmScript = document.createElement("script");
  gtmScript.id = "_gtm";
  gtmScript.async = true;
  gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${tagManagerKey}`;
  document.head.append(gtmScript);
};

export const pushEventToGTM = (eventData: {
  event: string;
  [key: string]: unknown;
}) => {
  window.dataLayer?.push(eventData);
};
